
// http://paulirish.com/2011/requestanimationframe-for-smart-animating/
// http://my.opera.com/emoller/blog/2011/12/20/requestanimationframe-for-smart-er-animating

// requestAnimationFrame polyfill by Erik Möller. fixes from Paul Irish and Tino Zijdel

// MIT license

(function() {
	var lastTime = 0;
	var vendors = ['ms', 'moz', 'webkit', 'o'];
	for(var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
		window.requestAnimationFrame = window[vendors[x]+'RequestAnimationFrame'];
		window.cancelAnimationFrame = window[vendors[x]+'CancelAnimationFrame']
			|| window[vendors[x]+'CancelRequestAnimationFrame'];
	}

	if (!window.requestAnimationFrame)
		window.requestAnimationFrame = function(callback, element) {
			var currTime = new Date().getTime();
			var timeToCall = Math.max(0, 16 - (currTime - lastTime));
			var id = window.setTimeout(function() { callback(currTime + timeToCall); },
				timeToCall);
			lastTime = currTime + timeToCall;
			return id;
		};

	if (!window.cancelAnimationFrame)
		window.cancelAnimationFrame = function(id) {
			clearTimeout(id);
		};
}());


const elementDataset = require("element-dataset").default;

function querySelectorScope(doc, proto) {
	try { // check if browser supports :scope natively
		doc.querySelector(':scope body');
	} catch (err) { // polyfill native methods if it doesn't
		['querySelector', 'querySelectorAll'].forEach(function (method) {
			var nativ = proto[method];
			proto[method] = function (selectors) {
				if (/(^|,)\s*:scope/.test(selectors)) { // only if selectors contains :scope
					var id = this.id; // remember current element id
					this.id = 'ID_' + Date.now(); // assign new unique id
					selectors = selectors.replace(/((^|,)\s*):scope/g, '$1#' + this.id); // replace :scope with #ID
					var result = doc[method](selectors);
					this.id = id; // restore previous id
					return result;
				} else {
					return nativ.call(this, selectors); // use native code for other selectors
				}
			}
		});
	}
}

function nodeListForEach() {
	if (typeof NodeList.prototype.forEach === "function") {
		return false;
	}

	NodeList.prototype.forEach = Array.prototype.forEach;
}

function reactClassStaticInheritance() {
	// Skip if the browser provides the __proto__ functionality
	if (Object.__proto__ != undefined) {
		return;
	}

	// Patch react.Component so that it works with transform-class-inherited-hook
	// and allows us to shim inherited static properties
	let React = require("react");

	class Component extends React.Component {
		static onInherited(child) {
			["onInherited", "propTypes", "defaultProps"].forEach(prop => {
				if (!child.hasOwnProperty(prop) && this.hasOwnProperty(prop)) {
					child[prop] = this[prop];
				}
			});
		}
	}

	React.Component = Component;
}

function arrayFrom() {
	if (typeof Array.from !== "function") {
		Array.from = arrayLike => Array.prototype.slice.call(arrayLike);
	}
}

module.exports = function () {
	querySelectorScope(window.document, Element.prototype);
	arrayFrom();
	nodeListForEach();
	elementDataset();
	reactClassStaticInheritance();
};